<template>
  <div class="mobile-menu">
    <overlay opacity=".9"></overlay>
    <div class="close-mobile-menu" @click="closeMenu"></div>
    <div class="profile-menu">
      <router-link to="/signin" class="hover-link light"><i class='uil uil-user'></i>Sign in</router-link>
    </div>
    <nav class="mobile-nav">
      <ul>
        <li>
          <router-link to="/signup">Features</router-link>
        </li>
        <li>
          <router-link to="/signup">Merchant</router-link>
        </li>
        <li>
          <router-link to="/signup">Developers</router-link>
        </li>
        <li>
          <router-link to="/signup">Partners</router-link>
        </li>
        <li>
          <router-link to="/signup">Pricing</router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import overlay from '@/components/Overlay.vue'

export default {
  components: {
    overlay
  },
  methods: {
    closeMenu() {
      this.$store.commit('toggleMenu')
    }
  }
};
</script>
